import React, { useState } from "react"

import { BookingOrderCancellationModalProps } from "models/bookingOrdersCancellation"
import ConfirmCancellationModal from "./ConfirmCancellationModal"
import SubmitCancellationModal from "./SubmitCancellationModal"
import ViewCancellationDetailsModal from "./ViewCancellationDetailsModal"

/**
 * Booking Order cancellation modal
 */
function BookingOrderCancellationModal(
  props: BookingOrderCancellationModalProps,
) {
  const [isCancellationConfirmed, setIsCancellationConfirmed] = useState(false)

  /**
   * Confirmation modal - triggered when user confirm cancellation
   */
  const handleConfirmCancellation = () => {
    setIsCancellationConfirmed(true)
  }

  /**
   * Confirmation modal - triggered when user press cancel button
   */
  const handleCancelCancellation = () => {
    setIsCancellationConfirmed(false)
    if (props.onFailedCancellation) props.onFailedCancellation()
  }

  /**
   * Submit cancellation modal -  triggered when user press cancel or close button
   */
  const handleCancellationResult = () => {
    setIsCancellationConfirmed(false)
    if (props.onCloseCancellation) props.onCloseCancellation()
  }

  /**
   * Submit cancellation modal (Read only mode) -  triggered when user press cancel or close button
   */
  const handleCloseReadOnlyModal = () => {
    if (props.onCloseReadOnlyModal) props.onCloseReadOnlyModal()
  }

  return (
    <>
      {!props.readonlyMode &&
        props.open &&
        (isCancellationConfirmed ? (
          <SubmitCancellationModal
            bookingOrderId={props.bookingOrderId ?? ""}
            bookingOrderName={props.bookingOrderName ?? ""}
            open={isCancellationConfirmed}
            onClose={handleCancellationResult}
            onSuccessCancellation={props.onSuccessCancellation}
          />
        ) : (
          <ConfirmCancellationModal
            isOpen={!isCancellationConfirmed}
            onAccept={handleConfirmCancellation}
            onCancel={handleCancelCancellation}
          />
        ))}

      {props.readonlyMode && (
        <ViewCancellationDetailsModal
          open={props.open}
          onClose={handleCloseReadOnlyModal}
          bookingOrderId={props.bookingOrderId ?? ""}
          bookingOrderName={props.bookingOrderName ?? ""}
        />
      )}
    </>
  )
}

export default BookingOrderCancellationModal
